import { Container, ContainerHeaderProps, Stack } from '@chronosphereio/chrono-ui';
import { useVizContainerContext } from '../context/VizContainerContextProvider';

export interface VizContainerHeaderBaseProps extends Omit<ContainerHeaderProps, 'variant'> {}

/**
 * Optional header component for rendering a title, description, and actions that help provide
 * additional information and interactions with the content of a `VizContainer`.
 *
 * It extends from the chrono-ui `Container.Header` component and shares similar props and behavior, when possible,
 * for consistency.
 *
 * This is the "base" version of the component that comes with very minimal features and dependencies on context.
 * Instead use `Header` if you want a more feature-rich root component.
 */
export const VizContainerHeaderBase = ({ children, ...containerProps }: VizContainerHeaderBaseProps) => {
  const { variant } = useVizContainerContext();

  return (
    <Container.Header {...containerProps} variant={variant}>
      {typeof children === 'string' ? (
        // If children is just a string, render it directly, so the text ellipsizing from `Container` works.
        children
      ) : (
        // If children is a react component, wrap in a stack, so things are nicely aligned.
        <Stack direction="row" spacing={1} alignItems="center">
          {children}
        </Stack>
      )}
    </Container.Header>
  );
};
